angular.module('account.templates', [])
angular.module('account.templates.dred', [])
angular.module('account.templates.sd', [])
angular.module('account.templates.zava', [])
angular.module('account.templates.asda', [])

// dred brand context
const dredTemplates = require.context('../', true, /^.+dred\.html$/)
dredTemplates.keys().forEach(dredTemplates)

// superdrug brand context
const sdTemplates = require.context('../', true, /^.+sd\.html$/)
sdTemplates.keys().forEach(sdTemplates)

// zava brand context
const zavaTemplates = require.context('../', true, /^.+zava\.html$/)
zavaTemplates.keys().forEach(zavaTemplates)

// asda brand context
const asdaTemplates = require.context('../', true, /^.+asda\.html$/)
asdaTemplates.keys().forEach(asdaTemplates)

// generic brand context
const genericTemplates = require.context('../', true, /^.+\/.+\/((?!(zava|dred|sd|asda)).)*html$/)
genericTemplates.keys().forEach(genericTemplates)
